import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedComic from './components/FeaturedComic';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import CTASection from './components/CTASection';

export default function Home() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '布丁漫画网',
    url: 'https://budingmanhua.com',
    description: '布丁漫画网提供洞洞杂货铺漫画全集下拉式免费阅读，无删减内容+流畅加载，全章节覆盖。海量优质中文漫画在线免费阅读平台。',
    sameAs: ['https://weibo.com/budingmanhua', 'https://weixin.qq.com/budingmanhua'],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '布丁漫画网',
    url: 'https://budingmanhua.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://budingmanhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '洞洞杂货铺漫画-漫画全集下拉式免费阅读-布丁漫画网',
    description: '洞洞杂货铺漫画全集下拉式免费阅读就在布丁漫画网，无删减内容+流畅加载，全章节覆盖，让您轻松追完整个故事。',
    url: 'https://budingmanhua.com',
    isPartOf: { '@type': 'WebSite', name: '布丁漫画网', url: 'https://budingmanhua.com' },
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="洞洞杂货铺漫画-漫画全集下拉式免费阅读-布丁漫画网"
        description="洞洞杂货铺漫画全集下拉式免费阅读就在布丁漫画网，无删减内容+流畅加载，全章节覆盖，让您轻松追完整个故事。海量优质漫画每日更新，支持下拉式连续阅读，沉浸式体验。"
        keywords="洞洞杂货铺,漫画全集,下拉式免费阅读,布丁漫画网,无删减内容,流畅加载,全章节,在线漫画,中文漫画,免费漫画"
        canonicalUrl="https://budingmanhua.com"
        schemaJsonLd={[organizationSchema, websiteSchema, webpageSchema]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedComic />
        <CategoryGrid />
        <LatestUpdates />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}